import { NativeStackScreenProps } from "@react-navigation/native-stack";

import { StoreProductPage } from "./StoreProductPage";
import { StoreStackNavigatorParamList } from "./StoreStackNavigator";

type Props = NativeStackScreenProps<
  StoreStackNavigatorParamList,
  "Memberships"
>;

export const StoreMembershipsPage = ({ navigation, route }: Props) => {
  return (
    <StoreProductPage
      selectedPackageId={route.params?.membershipId}
      onSelectedPackageClose={() =>
        navigation.setParams({ membershipId: undefined })
      }
      type="MEMBERSHIP"
    />
  );
};
